import { EPosition } from 'src/styles/theme/utils/enums';
import { addFramesStyles } from 'src/styles/theme/utils/functions';
import styled from 'styled-components';
import { INGSeparator } from './NGSeparator.type';

export const StyledNGSeparator = styled.div<INGSeparator>`
	display: flex;
	align-items: center;

	position: relative;

	${(p) => {
		if (!p.rhombusPosition) {
			return '';
		}
		switch (p.rhombusPosition) {
			case EPosition.center:
				return `justify-content: center;`;
			case EPosition.left:
				return `justify-content: flex-start;`;
			case EPosition.right:
				return `justify-content: flex-end;`;
			case EPosition.none:
				return `& > div {
          display: none;
        }`;
			default:
				return `& > div {
          display: none;
        }`;
		}
	}}

	height: 1px;
	width: 100%;

	${(p) => addFramesStyles(p)}

	background-color: ${(p) => `${p.theme.colors.gold}`};

	margin: ${(p) => p.theme.spacing[p.marginSize || '4xl']} 0;
`;

export const StyledRhombus = styled.div`
	position: absolute;

	width: 10px;
	height: 10px;

	background-color: ${(p) => `${p.theme.colors.gold}`};

	transform: rotate(45deg);
`;
